import React from 'react';
import './BubbleNetwork.css';

const BubbleNetwork = () => {
  return (
    <div className="bubble-container">
      <svg  className="bubble" viewBox="0 0 200 200">
        {/* Lines */}
        <line className="line" x1="100" y1="100" x2="150" y2="100" />
        <line className="line" x1="100" y1="100" x2="130" y2="60" />
        <line className="line" x1="100" y1="100" x2="70" y2="60" />
        <line className="line" x1="100" y1="100" x2="50" y2="100" />
        <line className="line" x1="100" y1="100" x2="70" y2="140" />
        <line className="line" x1="100" y1="100" x2="130" y2="140" />
        <line className="line" x1="150" y1="100" x2="180" y2="100" />
        <line className="line" x1="130" y1="60" x2="160" y2="40" />
        <line className="line" x1="70" y1="60" x2="40" y2="40" />
        <line className="line" x1="50" y1="100" x2="20" y2="100" />
        <line className="line" x1="70" y1="140" x2="40" y2="160" />
        <line className="line" x1="130" y1="140" x2="160" y2="160" />
        <line className="line" x1="100" y1="100" x2="100" y2="30" />
        <line className="line" x1="100" y1="100" x2="100" y2="170" />
        <line className="line" x1="50" y1="100" x2="30" y2="70" />
        <line className="line" x1="150" y1="100" x2="170" y2="70" />

        {/* Circles */}
        {[
          [100, 100], [150, 100], [130, 60], [70, 60],
          [50, 100], [70, 140], [130, 140], [180, 100],
          [160, 40], [40, 40], [20, 100], [40, 160],
          [160, 160], [100, 30], [100, 170], [30, 70], [170, 70],
        ].map(([cx, cy], i) => (
          <circle className="node" key={i} cx={cx} cy={cy} r="6" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </svg>
    </div>
  );
};

export default BubbleNetwork;
